<template>
  <div>
    <div>
      <el-form class="reports-create" label-position="top">
        <div class="reports-edit-header" v-if="$route.params.id && $route.name !== 'reportsCopy' && !form.is_temp">
          <div @click="deleteReport" class="i-container">
            <i class="el-icon-delete"></i>
            <span>Удалить отчет</span>
          </div>
          <router-link
            :to="`/dashboard/reports/create/${$route.params.id}/${$route.params.type}/copy`"
            class="i-container"
          >
            <i class="el-icon-document-copy"></i>
            <span>Копировать отчет</span>
          </router-link>
          <div class="i-container" @click="sendReport">
            <i class="fa  fa-paper-plane-o" style="font-size: 20px"></i>
            <span>Отправить отчет</span>
          </div>
        </div>
        <div class="date-create">
          <el-date-picker
            :disabled="!!from"
            :editable="false"
            format="yyyy-MM-dd"
            v-model="form.datetime"
            type="date"
            placeholder="Укажите дату"
          >
          </el-date-picker>
          <h4>
            <small>Номер отчета</small>
            #{{ form.index }}
          </h4>
        </div>

        <div v-if="$route.params.type !== 'COVID' && $route.params.type !== 'WILD_PIPE'">
          <div class="add-btn">
            <AddObjects
              v-if="!from"
              :isSelect="!!form.object"
              @add-objects="addObject"
            />
            <div class="report-li-title" v-if="form.object">
              Выбранный объект: <strong>{{ ` ` + form.object.name }}</strong>
            </div>
          </div>
          <div
            class="report-add-job reports-mul"

            v-if="$route.params.type === 'TECH' || $route.params.type === 'PROF' || $route.params.type === 'MATERIALS'"
          >
            <div
              style="width: calc(100% - 30px)"
              class="line-data" v-for="(jobs, index) in form.jobs"
            >
              <div class="pipe-close" style="margin-bottom: 0; margin-top: -10px">
                <i class="el-icon-close" @click="deleteJobs(index)" v-if="form.jobs.length > 1"/>
              </div>
              <div class="report-ul mul">
                <!--                <filter-select-->
                <!--                  v-if="$route.params.type === 'MATERIALS'"-->
                <!--                  v-model="form.work_type[index]"-->
                <!--                  label="Работа"-->
                <!--                  :options="options_works"-->
                <!--                />-->
                <AddJobs
                  v-if="$route.params.type === 'MATERIALS' && !form.jobs_internal[index]"
                  @add-job="addJobMaterials"
                  type="JOB"
                  :index="index"
                  :obj="form.object"
                  style="margin-bottom: 20px"
                />
                <div v-if="form.jobs_internal && form.jobs_internal[index]">
                  <div class="report-li">
                    {{ form.jobs_internal[index] && form.jobs_internal[index].job.name }}
                    <div class="report-value">
                      <el-input type="number" v-model="form.jobs_internal[index].value"/>
                      <strong>
                        {{ form.jobs_internal[index] && form.jobs_internal[index].job.unit }}
                      </strong>
                      <i @click="deleteJobInternal(index)" class="el-icon-close"></i>
                    </div>
                  </div>
                </div>
                <AddJobs
                  :unit_prop="form.jobs_internal[index] && form.jobs_internal[index].job && form.jobs_internal[index].job.unit"
                  @add-job="addJob" :index="index" :obj="form.object"/>
                <div
                  v-for="(job, i) in jobs" :key="i"
                  class="jobs-li"
                >
                  <div class="report-li with-check">
                    <span>{{ job.job && job.job.name }} {{ job.job.unit && `, ${job.job.unit}` }}</span>
                    <div class="report-value">
                      <el-form-item :label="$route.params.type === 'MATERIALS' && !job.job.is_unit_value ? '' : 'Ед.'"
                                    class="col-vo">
                        <el-input @input="calculateTotal(job)" type="number" v-model="job.value"/>
                      </el-form-item>
                      <template v-if="job.job.is_unit_value">
                        <el-form-item :label="`Итог`" class="col-vo">
                          <el-input
                            type="number" v-model="job.total"
                          />
                        </el-form-item>
                      </template>
                      <el-form-item
                        label="Часы"
                        class="time"
                        v-if="available_reports && available_reports[`${$route.params.type}_TIME`]"
                      >
                        <el-input
                          type="number"
                          v-model="job.time"
                        />
                      </el-form-item>
                      <i @click="deleteJob(i, index)" class="el-icon-close"></i>
                    </div>
                  </div>
                  <el-checkbox
                    v-if="$route.params.type === 'MATERIALS'"
                    v-model="job.is_select"
                    label="Добавить в объем"
                  ></el-checkbox>
                </div>
                <filter-select
                  v-if="$route.params.type !== 'MATERIALS'"
                  v-model="form.work_type[index]"
                  label="Вид работы"
                  :options="options_works"
                />
                <div v-if="$route.params.type === 'MATERIALS'" class="total">
                  <span>Итого: <strong>{{ getTotalMaterials(jobs, form.work_type[index]) }}</strong></span>
                  <el-button
                    size="small"
                    @click="form.jobs_internal[index].value = Number(getTotalMaterials(jobs, form.work_type[index]) || 0)"
                  >
                    + Добавить к факту
                  </el-button>
                </div>
                <el-form-item :label="'Место работы'" v-if="form.jobs_internal && form.jobs_internal[index]">
                  <el-input v-model="form.jobs_internal[index].place"/>
                </el-form-item>
              </div>

            </div>

            <div
              class="add-block"
              v-if="$route.params.type === 'TECH' || $route.params.type === 'PROF' || $route.params.type === 'MATERIALS'"
            >
              <el-button type="default" class="add-job" @click="form.jobs.push([])">Добавить</el-button>
            </div>
          </div>


          <div class="report-add-job" v-else>
            <div class="report-ul">
              <div
                v-for="(job, index) in form.jobs" :key="index" class="report-li"
              >
                <div v-if="!job.is_daily" style="width: 100%">
                  <span style="margin-bottom: 10px">{{ job.job && job.job.name }}</span>
                  <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 15px">
                    <div class="report-value" v-if="!job.is_daily">
                      <el-input type="number" v-model="job.value"/>
                    </div>
                    <div>
                      <strong>
                        {{ job.job.unit }}
                      </strong>
                      <i @click="deleteJob(index)" class="el-icon-close"></i>
                    </div>
                  </div>
                  <el-input
                    style="margin-top: 10px;"
                    placeholder="Комментарий"
                    type="textarea"
                    v-model="job.comment"
                  />
                </div>
                <div v-else>
                  <div class="report-value" style="justify-content: space-between">
                    <strong>{{ job.job && job.job.name }}, {{ job.job.unit }}</strong>
                    <i @click="deleteJob(index)" class="el-icon-close"></i>
                  </div>
                  <div style="margin-top: 10px">
                    <el-row>
                      <el-col :span="12">
                        <el-input type="number" v-model="job.daily_plan"/>
                      </el-col>
                      <el-col :span="12">
                        <el-input type="number" v-model="job.value"/>
                      </el-col>
                    </el-row>
                    <el-input
                      style="margin-top: 10px;"
                      placeholder="Комментарий"
                      type="textarea"
                      v-model="job.comment"
                    />
                  </div>

                </div>
              </div>
              <AddJobs
                :type="$route.params.type === 'MAIN' ? 'JOB' : undefined"
                @add-job="addJob" :obj="form.object"/>
            </div>
          </div>
        </div>

        <el-form-item :label="'Место работы'" v-if="$route.params.type === 'MAIN'">
          <el-input v-model="form.place"/>
        </el-form-item>

        <filter-select
          v-if="$route.params.type === 'MATERIALS' || $route.params.type === 'MAIN'"
          v-model="form.leader"
          label="Исполнитель"
          :options="joint_options.executor"
        />

        <div v-if="$route.params.type === 'WILD_PIPE'">
          <filter-select
            :value="form.line"
            @input="pickLine"
            label="Линия"
            :options="joint_options.lines"
          />

          <div class="line-data" v-for="(joint, index) in form.joints" :key="index" v-if="updated">
            <div class="pipe-close">
              <i class="el-icon-close" @click="deleteJoint(index)" v-if="form.joints.length > 1"/>
              <add-joint :line="current_line" @update="update" :joint="index"/>
            </div>


            <filter-select
              multiple
              @input="checkJoint"
              v-model="joint.id_joint"
              label="Номера стыков"
              :options="joint_options.joints"
            />

            <filter-select
              multiple
              v-model="joint.welder"
              single
              label="Сварщики"
              :options="joint_options.welders"
            />

            <filter-select
              multiple
              v-model="joint.materials"
              single
              label="Сварочные материалы"
              :options="joint_options.materials"
            />

            <filter-select
              v-model="joint.leader"
              label="Бригадир"
              :options="joint_options.team"
            />

            <el-form-item label="Оси и отметка">
              <el-input v-model="joint.axe_elevation"/>
            </el-form-item>
          </div>
          <div class="add-block">
            <el-button @click="addJoint">Добавить</el-button>
          </div>
        </div>


        <div class="create-comment">

          <filter-select
            :disabled="!!from"
            v-model="form.turn"
            label="Смена"
            :options="shifts"
          />

          <div style="display: flex; flex-direction: column" v-if="$route.params.type === 'JOB'">
            <div v-if="available_reports && available_reports.PROF">
              <div class="dop-container" style="margin-bottom: 10px">
                <strong>Численность</strong>
                <div class="report-child-btn">
                  <strong style="margin-right: 10px" v-if="form.PROF.index">#{{ form.PROF.index }}</strong>
                  <el-button @click="createReport('PROF')">
                    Отчет
                  </el-button>
                </div>
              </div>
              <el-row v-if="form.reportPROF">
                <el-col :span="12">
                  <el-input type="number" disabled placeholder="Рабочие" v-model="form.PROF.workers"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-input type="number" disabled placeholder="ИТР" v-model="form.PROF.itr"></el-input>
                </el-col>
              </el-row>
            </div>
            <div v-if="available_reports && available_reports.TECH">
              <div class="dop-container" style="margin-top: 30px; margin-bottom: 10px">
                <strong>Техника</strong>
                <div class="report-child-btn">
                  <strong style="margin-right: 10px" v-if="form.TECH.index">#{{ form.TECH.index }}</strong>
                  <el-button @click="createReport('TECH')">
                    Отчет
                  </el-button>
                </div>
              </div>
              <el-input v-if="form.reportTECH" disabled type="number" placeholder="Единиц техники"
                        v-model="form.TECH.workers">

              </el-input>
            </div>
          </div>

          <el-form-item label="Сменный план"
                        v-if="($store.state.project.daily_plan && !from &&  ($route.params.type === 'TECH' || $route.params.type === 'PROF'))">
            <el-row v-if="$route.params.type !== 'TECH'">
              <el-col :span="12">
                <el-input type="number" placeholder="Рабочие" v-model="form.daily_plan.workers"></el-input>
              </el-col>
              <el-col :span="12">
                <el-input type="number" placeholder="ИТР" v-model="form.daily_plan.itr"></el-input>
              </el-col>
            </el-row>
            <el-input v-else type="number" placeholder="Единиц техники"
                      v-model="form.daily_plan.workers"></el-input>
          </el-form-item>

          <a @click="toParent" class="job-link" v-if="from">Отчет по работам #{{ parent.index }}</a>

          <el-form-item label="Комментарии">
            <el-input type="textarea" v-model="form.comment"></el-input>
          </el-form-item>
        </div>

        <div class="report-file">
          <UploadFile
            :fileListProps="fileList"
            @add-file="addFile"
          />
          <div :key="index" v-for="(file, index) in form.files" class="links-list">
            <a target="_blank" :href="file">Прикрепленный файл #{{ index + 1 }}</a>
            <i class="el-icon-delete" @click="deleteImg(index)"></i>
          </div>
          <!--          <div class="preview-images">-->

          <!--            <div class="preview-img" :key="index" v-for="(file, index) in form.files">-->
          <!--              <img :src="file"/>-->
          <!--              <div class="controls">-->
          <!--                <i class="el-icon-delete" @click="deleteImg"></i>-->
          <!--                <i class="el-icon-search" @click="preview(file)"></i>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <el-dialog :visible.sync="dialogObject">
          <img style="width: 100%;" :src="previewSrc">
        </el-dialog>

        <div class="create-footer">
          <el-button @click="back()">Отмена</el-button>
          <el-button type="primary" @click="saveReport()">Сохранить</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import AddObjects from './components/AddObjects';
import AddJobs from './components/AddJobs';
import UploadFile from '@/views/Dashboard/Reports/components/UploadFile';
import firebase from 'firebase';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import AddJoint from './components/AddJoint';
import FilterSelect from '../../../components/FilterSelect';
import _ from 'lodash';
import {toFloat} from '../../../utils/numberUtils';
import {BigNumber} from 'bignumber.js';
import {copyChild, fetchIndex, updateFrom} from "../../../firestore/reports";
// /#/dashboard/reports/create/TECH?form=kek
export default {
  name: 'Create',
  components: {FilterSelect, AddJoint, UploadFile, AddJobs, AddObjects, Multiselect},
  data() {
    return {
      ...this.emptyData()
    }
  },

  async mounted() {
    const available_reports = this.$store.state.project.available_reports || {};
    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }
    this.init();
  },
  watch: {
    '$route.params': {
      handler() {
        this.init();
      },
      deep: true,
    },
  },

  methods: {
    emptyData() {
      let job = [];

      if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF' || this.$route.params.type === 'MATERIALS') {
        job = [[]];
      }

      return {
        from: null,
        searchable: {
          line: false,
        },
        totalMaterials: 0,
        updated: true,
        fileList: [],
        loader: false,
        dialogObject: false,
        previewSrc: null,
        loading: false,
        isCreatedUser: false,
        joint_options: {
          lines: [],
          joints: [],
          welders: [],
          materials: [],
          team: [],
          executor: [],
        },
        shifts: [{
          label: 1,
          value: 1,
        }, {
          label: 2,
          value: 2,
        }, {
          label: 3,
          value: 3,
        }],
        user: {},
        current_line: {},
        options_works: [],
        available_reports: {
          JOB: true,
          TECH: true,
          PROF: true,
          COVID: true,
          WILD_PIPE: false,
          MATERIALS: false,
          MAIN: false,
        },
        parent: {},
        form: {
          reportTECH: null,
          reportPROF: null,
          TECH: {
            workers: '',
          },
          PROF: {
            workers: '',
            itr: '',
          },
          jobs_internal: [],
          work_type: [],
          daily_plan: {
            workers: '',
            itr: '',
          },
          joints: [{
            id_joint: null,
            welder: null,
            materials: null,
            leader: null,
            axe_elevation: null,
          }],
          leader: null,
          place: null,
          line: null,
          datetime: dayjs().format(),
          dateunix: dayjs(dayjs().format('YYYY-MM-DD') + 'T00:00:00+00:00').utc().unix(),
          comment: '',
          object: '',
          group: [],
          jobs: this.$route.params.type === 'COVID' ? {
            main: 0,
            fall: 0,
          } : job,
          index: 1,
          files: [],
          turn: {
            value: 1,
            label: 1,
          },
        },
      };
    },
    toParent() {
      this.$router.push({
        path: `/dashboard/reports/create/${this.from}/JOB`,
        query: {
          from: null
        }
      })
    },
    async createReport(type) {
      const id = await this.save(true);
      if (this.form[`report${type}`]) {
        await this.$router.push({
          path: `/dashboard/reports/create/${this.form[`report${type}`]}/${type}`,
          query: {
            from: id
          }
        });
      } else {
        await this.$router.push({
          path: `/dashboard/reports/create/${type}`,
          query: {
            from: id
          }
        });
      }
    },
    async back() {
      if (this.$route.params.id && this.form.is_temp) {
        this.removeReport(true);
      }

      if (this.$route.query.from) {
        await this.$router.push({
          path: `/dashboard/reports/create/${this.from}/JOB`,
          query: {
            from: null
          }
        });
      } else {
        await this.$router.push({
          path: `/dashboard/reports/${this.$route.params.type}`,
          query: {
            from: null
          }
        });
      }
    },
    saveReport() {
      this.save().catch((e) => console.log(e));
    },
    async fetchFrom() {
      this.parent = {}

      if (!this.from) {
        return null
      }
      const report = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.from).get()

      const data = report.data();

      this.parent = data;

      this.form = {
        ...this.form,
        object: data.object,
        turn: data.turn,
        datetime: data.datetime,
        dateunix: data.dateunix,
      }
    },
    calculateTotal(input) {
      input.total = new BigNumber(input.value.replace(',', '.'))
        .multipliedBy(input.job.unit_value.replace(',', '.')).toNumber()
    },
    getTotalMaterials(_jobs, work_type) {
      const jobs = _jobs.filter((job) => job.is_select);
      const count = jobs.reduce(function (a, b) {
        if (b.job.is_unit_value) {
          return a + Number(String(b['total']).replace(',', '.'));
        } else {
          return a + Number(b['value']);
        }
      }, 0);
      return `${+count.toFixed(4)} ${work_type ? work_type.value : ''}`;

    },
    async addObject(n) {
      if (this.$route.params.type === 'JOB' || this.$route.params.type === 'MAIN') {
        this.form.jobs = [];
        this.form.jobs_internal = [];
      }

      if (this.$route.params.type === 'MATERIALS') {
        this.form.jobs = [[]];
        this.form.jobs_internal = [];
        await this.getOptionalWork();
      }

      this.form.object = n;
    },
    changeValues(job) {
      if (this.$route.params.type === 'MATERIALS' && job.job.unit_value) {
        job.total = Number(job.job.unit_value) * Number(job.value);
      }
    },
    checkJoint(joints) {
      const joint = joints[joints.length - 1];
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .where('joints_ids', 'array-contains-any', [`${joint.line}.${joint.id}`])
        .get().then((d) => {
        if (d.size) {
          this.$confirm(`Вы действительно хотите записать стык с номером ${joint.id} ?`,
            `Стык с номером ${joint.id} уже сварен`, {
              confirmButtonText: 'Да',
              cancelButtonText: 'Нет',
              type: 'warning',
            }).catch(() => {
            joints.pop();
          });
        }
      });
    },
    openDialog(line) {
      this.$confirm('После смены линии вся введенная информация по стыкам будет удалена, продолжить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        this.updated = false;
        this.form.joints = [{
          id_joint: null,
          welder: null,
          materials: null,
          leader: null,
          axe_elevation: null,
        }];
        this.pickLine(line);
        this.updated = true;

      });
    },
    async init() {
      this.loader = false;
      await this.getOptionalWork();
      const empty = this.emptyData();
      this.form = {
        ...empty.form
      }

      this.jobs = empty.jobs;

      this.jobs_internal = empty.jobs_internal;
      this.work_type = empty.work_type;

      this.from = this.$route.query.from;

      await this.fetchUser();
      if (this.$route.params.id) {
        await this.fetchData();
        if (this.$route.name === 'reportsCopy') {
          this.form.datetime = dayjs().format();
          this.from = null;

          this.parent = {}

          this.form = {
            ...(await copyChild(this.form, this.$store.state.project.id)),
            from: null
          }
        }
      } else {
        this.fetchIndex();
      }
      this.fetchFrom();
      if (this.$route.params.type === 'WILD_PIPE') {
        this.joint_options.lines = await this.getWorkType('line');
        this.joint_options.welders = await this.getWorkType('welder');
        this.joint_options.materials = await this.getWorkType('welder_cons');
        this.joint_options.team = await this.getWorkType('team');
        if (this.form.line) {
          this.pickLine(this.form.line);
        }
      } else {
        this.joint_options.executor = await this.getWorkType('executor');
      }
    },
    sendReport() {
      this.$prompt('Пожалуйста введите email', 'Отправка отчета', {
        confirmButtonText: 'Отправить',
        inputValue: firebase.auth().currentUser.email,
        cancelButtonText: 'Закрыть',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: 'Некорректный емайл',
      }).then(({value}) => {
        this.loading = true;
        const proxy = firebase.functions().httpsCallable('onMailReports');
        proxy(
          {
            projectId: this.$store.state.project.id,
            reportId: this.$route.params.id,
            email: value,
          },
        ).then(() => {
          this.$notify({
            offset: 60,

            title: 'Успешно!',
            message: 'Отчет отправлен вам на почту',
            type: 'success',
          });
        }).catch(() => {
          this.$notify({
            offset: 60,

            title: 'Ошибка',
            message: 'Произошла ошибка, попробуйте позже',
            type: 'error',
          });
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    async getOptionalWork() {
      let req = null;
      const result = [];

      if (this.$route.params.type !== 'MATERIALS') {
        req = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', 'in', ['job', 'JOB']);


      } else {
        req = firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('jobs')
          .where('type', '==', 'JOB')
          .where(`objects`, 'array-contains-any', [this.form.object && this.form.object.id || 'all']);
      }

      await req.get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              label: data.name,
              value: data.unit,
              id: data.id || subDoc.id,
            });
          });
        })
        .finally(() => {
          this.options_works = [
            {
              label: 'Не выбрано',
              value: null,
            },
            ...result,
          ];
        });
    },
    async removeReport(flag) {
      if (this.from) {
        await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.from)
          .update({
            [`report${this.$route.params.type}`]: null,
            [this.$route.params.type]: {
              workers: '',
              itr: ''
            }
          });
      }

      if (this.form[`reportTECH`]) {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.form[`reportTECH`]).delete()
      }

      if (this.form[`reportPROF`]) {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('reports')
          .doc(this.form[`reportPROF`]).delete()
      }

      if(this.$route.name === 'reportsCopy') {
        this.$router.push(`/dashboard/reports/${this.$route.params.type}`);

        return
      }


      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.$route.params.id).delete()
        .then((data) => {
          if (!flag) {
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'Отчет удален',
              type: 'success',
            });
          }
          setTimeout(() => {
            this.form.is_temp = false
            this.back();
          }, 1000);
        });
    },
    deleteReport() {
      this.$confirm('Вы действительно хотите удалить этот отчет?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(async () => {
        this.removeReport();
      });
    },
    fetchUser() {
      this.loading = true;
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .where('uid', '==', this.$store.state.company.uid || firebase.auth().currentUser.uid)
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const user = subDoc.data();
            if (user.name.length && user.position.length) {
              this.isCreatedUser = subDoc.id;
            }
            this.user = {
              ...user,
              name: user.name || firebase.auth().currentUser.email,
              user_profile_id: subDoc.id,
            };
          });

        }).finally(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    deleteJoint(index) {
      const joints = this.form.joints;
      joints.splice(index, 1);
      this.form.joints = joints;
    },
    deleteJobs(index) {
      const jobs = this.form.jobs;
      const work_type = this.form.work_type;

      jobs.splice(index, 1);

      if (work_type.length) {
        work_type.splice(index, 1);
      }

      this.form.jobs = jobs;
      this.form.work_type = work_type;
    },
    update({data, new_joint, joint}) {
      const joint_add = {
        ...new_joint,
        dia: toFloat(new_joint.dia),
        thi: toFloat(new_joint.thi),
        inc: toFloat(new_joint.inc),
        label: String(new_joint.id),
        value: String(new_joint.id),
        steel_grade: String(new_joint.steel_grade),
      };
      this.form.line.data = data;
      this.pickLine(this.form.line, joint_add);

      if (this.form.joints[joint].id_joint) {
        this.form.joints[joint].id_joint.push(joint_add);
      } else {
        this.form.joints[joint].id_joint = [joint_add];
      }
    },
    pickLine(line, new_line = null) {
      const c = {...this.form.line};
      try {
        if (!line.value) return;
        const current_line = this.joint_options.lines.find((f) => f.value === line.value);
        this.current_line = current_line;

        this.form.line = line;
        if (c.label && line.value !== c.value) {
          this.openDialog(line);
        } else {
          const joints = current_line && current_line.data ? current_line.data.joints.map((joint) => ({
            ...joint,
            dia: toFloat(joint.dia),
            thi: toFloat(joint.thi),
            inc: toFloat(joint.inc),
            line: line.value,
            label: String(joint.id),
            value: String(joint.id),
            steel_grade: String(joint.steel_grade),
            i: Number(joint.id),
          })) : [];
          if (new_line) {
            joints.push(new_line);
          }
          this.joint_options.joints = _.orderBy(joints, 'i', 'asc');

          this.joint_options.joints = this.joint_options.joints.map((joint) => ({
            dia: toFloat(joint.dia),
            thi: toFloat(joint.thi),
            inc: toFloat(joint.inc),
            line: line.value,
            label: String(joint.id),
            value: String(joint.id),
            steel_grade: String(joint.steel_grade),
            id: joint.id,
          }));

        }
      } catch (e) {
        console.error(e);
      }
    },
    getWorkType(type) {
      return new Promise((resolve, reject) => {
        const result = [];
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          resolve(result);
        });
      });
    },
    preview(file) {
      window.open(file, '_blank');
    },
    addJoint() {
      this.form.joints.push({
        line: null,
        id_joint: null,
        welder: null,
        materials: null,
        leader: null,
        axe_elevation: null,
      });
    },
    addFile(f) {
      this.form.files.push(f);
    },
    deleteImg(id) {
      this.$confirm('Вы действительно хотите удалить этот файл?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        const images = [...this.form.files];
        images.splice(id, 1);
        this.form.files = images;
      });
    },
    fetchData() {
      return firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.$route.params.id)
        .get().then((data) => {
          const subData = data.data();
          this.fileList = this.form.files.map((f, i) => {
            return {
              url: f,
              name: 'file__' + i,
            };
          });

          if (this.$route.params.type === 'MATERIALS') {
            const {jobs_internal, jobs} = {...subData};
            subData.jobs = jobs_internal;
            subData.jobs_internal = jobs;
          }

          if (subData.from) {
            this.from = subData.from;
          }

          if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF' || this.$route.params.type === 'MATERIALS') {
            this.form = {
              ...this.form,
              ...subData,
              jobs: [...Object.values(subData.jobs)],
            };
          } else {
            this.form = {
              ...this.form,
              ...subData,
            };
          }
        });
    },
    async fetchIndex() {
      this.form.index = await fetchIndex(this.$store.state.project.id)
    },
    addJob(dd, index) {
      if (this.$route.params.type !== 'TECH' && this.$route.params.type !== 'PROF' && this.$route.params.type !== 'MATERIALS') {
        this.form.jobs.push(dd);
      } else {
        this.form.jobs[index].push(dd);
      }
    },
    addJobMaterials(dd, index) {
      const jobs_internal = this.form.jobs_internal;
      jobs_internal[index] = dd;
      this.form.jobs_internal = [
        ...jobs_internal,
      ];
    },
    deleteJob(index, mainIndex = null) {
      const jobs = [...this.form.jobs];

      if (mainIndex !== null) {
        jobs[mainIndex].splice(index, 1);
      } else {
        jobs.splice(index, 1);
      }
      this.form.jobs = [...jobs];
    },
    deleteJobInternal(index) {
      const jobs = [...this.form.jobs_internal];
      jobs.splice(index, 1);
      this.form.jobs_internal = [...jobs];
    },
    async save(flag) {
      return new Promise(async (resolve, reject) => {
        if (this.loader) return false;

        if (this.$route.params.type === 'WILD_PIPE') {
          for (let joint of this.form.joints) {
            if (!joint.id_joint || !joint.id_joint.length) {
              this.$notify({
                offset: 60,
                title: 'Ошибка!',
                message: 'Необходимо указать стыки во всех блоках',
                type: 'error',
              });
              return false;
            }
          }
        }

        this.loader = true;

        if (!this.form.datetime) {
          this.$notify({
            offset: 60,

            title: 'Заполните все поля!',
            message: 'Пожалуйста заполните поле c датой',
            type: 'error',
          });
          return;
        }

        let jobs = this.form.jobs;
        let jobs_ids = [];
        let work_type_ids = [];

        this.form.work_type = Array.from(this.form.work_type, item => typeof item === 'undefined' || !item.value ? null : item);

        if (this.$route.params.type === 'TECH' || this.$route.params.type === 'PROF' || this.$route.params.type === 'MATERIALS') {
          jobs.forEach((job) => job.forEach((j) => jobs_ids.push(j.job.id)));
          this.form.jobs.forEach((job, index) => {
            job.forEach((j, i) => {
              try {
                this.form.jobs[index][i].is_select = this.form.jobs[index][i].is_select || null;
                this.form.jobs[index][i].job.work_type_name = this.form.work_type[index].label || null;
                this.form.jobs[index][i].job.work_type = this.form.work_type[index].id || null;

                if (this.form.work_type[index].id) {
                  work_type_ids.push(this.form.work_type[index].id);
                }
              } catch (e) {
                this.form.jobs[index][i].is_select = this.form.jobs[index][i].is_select || null;
                this.form.jobs[index][i].job.work_type_name = null;
                console.error(e);
              }
            });
          });
          jobs = {...this.form.jobs};
        } else {
          jobs_ids = jobs.map((job) => job.job.id);
          work_type_ids = jobs.map((job) => job.job.work_type || null);
        }

        const joints_ids = [];
        if (this.form.joints && this.form.joints[0] && this.form.joints[0].id_joint) {
          this.form.joints.forEach((joint) => {
            if (joint.id_joint) {
              joint.id_joint.forEach((j) => {
                if (j.line) {
                  joints_ids.push(`${j.line}.${j.id}`);
                }
              });
            }
          });
        }

        let line = {};
        try {

          if (this.form.line) {
            const {
              name,
              stamp,
              type,
              id,
            } = this.form.line.data;

            line = {
              ...this.form.line,
              data: {
                id,
                name,
                stamp,
                type,
              },
            };
          }
        } catch (e) {
          console.log(e);
        }

        let wild_data = {};
        const user = firebase.auth().currentUser;

        if (!this.$route.params.id || this.$route.name === 'reportsCopy') {
          this.form.jobs_internal = this.form.jobs_internal.map((job) => {
            return {
              ...job,
              is_select: false
            }
          })

          if(this.$route.name !== 'reportsCopy') {
            await this.fetchIndex();
          }

          user.providerData.forEach(() => {
            if (this.$route.query.from) {
              this.form.from = this.$route.query.from;
            }

            this.form.is_temp = !!flag

            if (this.form.reportPROF) {
              this.updateSub(this.form.reportPROF)
            }

            if (this.form.reportTECH) {
              this.updateSub(this.form.reportTECH)
            }

            firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('reports')
              .add({
                ...this.form,
                jobs,
                joints_ids,
                jobs_ids,
                line,
                is_temp: !!flag,
                work_type_ids,
                extended_data: wild_data || null,
                datetime: dayjs(this.form.datetime).format(),
                userId: this.$store.state.company.uid || user.uid,
                type: this.$route.params.type,
                dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
                user: this.user,
              }).then(async (docRef) => {
              if (this.$route.name === 'reportsCopy') {
                await updateFrom(this.$store.state.project.id, this.form, docRef)
              }

              if (flag) {
                return resolve(docRef.id)
              } else {

                if (this.from) {
                  this.updateParent(docRef.id)
                }
                this.$notify({
                  offset: 60,

                  title: 'Успешно!',
                  message: 'Отчет добавлен',
                  type: 'success',
                });
                this.form = {
                  comment: '',
                  object: '',
                  jobs: [],
                  index: '-',
                };

                setTimeout(() => {
                  if (this.$route.query.from) {
                    return this.back();
                  }
                  this.$router.push('/dashboard/reports/' + this.$route.params.type);
                }, 1000);
              }
            }).finally(() => {
              this.loader = false;
            })
              .catch((error) => {
                this.$notify({
                  offset: 60,

                  title: 'Упс... ',
                  message: 'Произошла ошибка повторите позже',
                  type: 'error',
                });
              });
          });
        } else {
          let user = this.form.user;
          if (user.uid === firebase.auth().currentUser.uid || user.uid === this.$store.state.company.uid) {
            user = this.user;
          }

          if (this.form.reportPROF) {
            this.updateSub(this.form.reportPROF)
          }

          if (this.form.reportTECH) {
            this.updateSub(this.form.reportTECH)
          }

          if (this.from) {
            this.updateParent(this.$route.params.id,)
          }

          if (this.form.is_temp) {
            this.form.is_temp = !!flag
          }

          firebase.firestore()
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('reports')
            .doc(this.$route.params.id)
            .update({
              ...this.form,
              user: user,
              jobs,
              joints_ids,
              extended_data: wild_data || null,
              datetime: dayjs(this.form.datetime).format(),
              dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
            }).then(() => {
            if (flag) {
              return resolve(this.$route.params.id)
            } else {
              this.$notify({
                offset: 60,

                title: 'Успешно!',
                message: `Отчет сохранен`,
                type: 'success',
              });

              if (this.$route.query.from) {
                this.back()
              } else {
                this.$router.push(`/dashboard/reports/${this.$route.params.type}`);
              }
            }
          }).finally(() => {
            this.loader = false;
          }).catch((error) => {
            this.$notify({
              offset: 60,

              title: 'Упс... ',
              message: 'Произошла ошибка повторите позже',
              type: 'error',
            });
          });
        }
      });
    },
    async updateSub(id) {
      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(id)
        .update({
          object: this.form.object,
          turn: this.form.turn,
          datetime: dayjs(this.form.datetime).format(),
          dateunix: dayjs(dayjs(this.form.datetime).format('YYYY-MM-DD') + 'T00:00:00+00:00').unix(),
        });
    },
    async updateParent(id, index) {
      const result = {
        workers: 0,
        itr: 0,
        index: this.form.index,
      }
      this.form.jobs.forEach((jb) => {
        jb.forEach((j) => {
          if (j.job.kind && j.job.kind.value === 'itr') {
            result.itr = result.itr + Number(j.value)
          } else {
            result.workers = result.workers + Number(j.value)
          }
        });
      })


      await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('reports')
        .doc(this.from)
        .update({
          [`report${this.$route.params.type}`]: id,
          [this.$route.params.type]: result
        });
    }
  },

};
</script>
<style scoped lang="scss">

.navigate-btn {
  margin-top: 20px;
  display: block;
}

.reports-create, .alert-report {
  margin: 0 auto;
  max-width: 382px;
  padding-top: 20px;
  width: calc(100% - 40px);
  overflow: hidden;
  padding-bottom: 100px;

  .add-jobs {
    display: flex;
    flex-direction: column;
  }

  .date-create {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  h4 {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin: 0;

    small {
      font-size: 10px;
      font-weight: 400;
    }
  }
}

.add-btn {
  width: 100%;

  > > > .add {
    width: 100%;
  }

  margin-top: 20px;

  &.add-jobs {
    margin-top: 0;
  }
}

.select-job {
  margin-top: 20px;

  > > > .el-select {
    width: 100%;
  }
}

.report-li {
  span {
    max-width: 50%;
  }
}

.report-value {
  strong {
    font-weight: bold;
  }
}

@media screen and (max-width: 500px) {
  .report-value {
    width: 100%;
    justify-content: space-between !important;
  }

  .report-li {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;


    .el-icon-close {
      margin-bottom: 12px;
    }

    .col-vo, .time {
      display: flex;
      flex-direction: row;

      > > > .el-form-item__label {
        margin-right: 6px !important;
      }
    }

    .time {
      margin-left: 10px;
    }

    span {
      max-width: 100%;
      font-weight: bold;
    }
  }
}

.report-li-title {
  font-size: 14px;
  margin-top: 18px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 0px;
}

.report-add-job {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  padding: 20px 0;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;

  .report-ul {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-bottom: 22px;
  }

  .jobs-li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);

    &:last-child {
      border-bottom: none;
    }

    padding-bottom: 12px;
  }

  .report-li {
    display: flex;
    margin-top: 3px;
    justify-content: space-between;
    min-height: 58px;
    padding: 12px 0px;
    text-align: left;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;


    &.with-check {
      border-bottom: none;
      padding-bottom: 0px;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

.report-file {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-top: 18px;
}


.create-footer {
  display: flex;
  justify-content: space-between;
  position: fixed;
  height: 64px;
  border-top: 1px solid #ddd;
  align-items: center;
  max-width: 382px;
  width: calc(100% - 40px);
  bottom: 0;
  background: #fff;
  z-index: 3;
}

.report-ul {
  width: 100%;
}

.dop-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

> > > .el-form-item, > > > .el-form-item__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .el-form-item__label {
    padding: 0 !important;
    margin-top: 10px;
  }
}

.report-value {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  strong {
    opacity: 0.8;
    font-weight: bold;
  }

  > > > .el-input__inner {
    width: 92px;
    text-align: right;
    margin-right: 8px;
  }


}

.preview-images {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex: 1;
  margin-top: 16px;
  margin-bottom: 16px;

  .preview-img {
    width: 92px;
    height: 92px;
    margin: 6px;
  }

  .controls {
    display: flex;
    justify-content: space-between;
    background-color: rgba(0, 0, 0, 0.3);
    width: 92px;
    height: 92px;
    border-radius: 6px;
    margin-top: -98px;
    z-index: 2;
    position: relative;
    align-items: center;

    i {
      font-size: 24px;
      color: #fff;
      margin: 0 12px;
      cursor: pointer;
    }
  }

  img {
    width: 92px;
    height: 92px;
    border-radius: 6px;
    cursor: pointer;
    z-index: 1;
    position: relative;
  }
}

.add-block {
  display: flex;
  justify-content: flex-end;
}

.line-data {
  padding: 5px 15px;
  margin-bottom: 10px;
  background: #fff;
  background: #f7f7f7;
  box-shadow: 0px 0px 8px 0px #ccc;
  border-radius: 5px;
}

.pipe-close {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: -42px;
  margin-top: 10px;
  font-size: 20px;
  cursor: pointer;

  i {
    margin-bottom: 10px;
  }

  > > > .add-btn-joint {
    z-index: 2;
    position: relative;
  }
}

.reports-edit-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;

  .i-container {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    padding: 6px;
    cursor: pointer;
    border: 1px solid #eee;
    color: #000;
    text-decoration: none;
    flex-direction: column;

    i {
      height: 24px;
    }

    span {
      font-size: 10px;
      margin-top: 6px;
    }

    &:hover {
      background: #eee;
    }
  }
}

.reports-create {
  padding: 0 20px;
}

.add-job {
  margin-top: -30px;
}

.reports-create {
  padding-top: 40px;
  padding-bottom: 70px;
}

.report-add-job {
  .line-data {
    padding-top: 24px;
    margin-bottom: 20px;
  }

  .report-ul.mul {
    margin-bottom: 0;
  }

  .add-block {
    margin-top: 30px;
  }

  .report-li > > > .el-form-item__label {
    height: 32px;
  }

  .col-vo {
    > > > .el-input__inner {
      width: 68px !important;
      padding: 0 5px !important;
    }
  }

  .time {
    > > > .el-input__inner {
      width: 58px !important;
      padding: 0 8px 0 2px !important;
      margin-right: 0px;
    }
  }
}

.reports-mul {
  > > > .el-form-item__label {
    margin-top: 2px;
  }

  > > > .el-form-item {
    margin-bottom: 10px;
  }
}

.total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 14px;
}

.links-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 20px;
  align-items: center;

  a {
    color: #3676cb;
    font-size: 14px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  i {
    cursor: pointer;
    font-size: 20px;
    opacity: 0.8;
  }
}

.report-child-btn {
  display: flex;
  align-items: center;
}

.job-link {
  display: flex;
  text-align: left;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Reports/Create.vue